package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val NewsletterInputStyle = CssStyle {
    base {
        Modifier
            .borderRadius(6.px)
            .border(1.px, LineStyle.Solid, Color.rgba(255, 255, 255, 0.3f))
            .backgroundColor(Color.rgba(255, 255, 255, 0.1f))
            .color(HLDITheme.Colors.white)
            .fontSize(14.px)
    }

    cssRule("::placeholder") {
        Modifier.color(Color.rgba(255, 255, 255, 0.7f))
    }
}